export default {
  exchange (amount, cb, errorCb) {
    axios.post('/chip/exchange', { amount: amount })
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/api/chip.js